import { Task } from './types';
import { daysFromToday } from './dates';

export type BucketKey = 'overdue' | 'today' | 'thisWeek' | 'nextWeek' | 'later';

export const BUCKET_LABEL: Record<BucketKey, string> = {
  overdue: 'Overdue',
  today: 'Today',
  thisWeek: 'This week',
  nextWeek: 'Next week',
  later: 'Later',
};

export const BUCKET_ORDER: BucketKey[] = ['overdue', 'today', 'thisWeek', 'nextWeek', 'later'];

export const bucketFor = (task: Task): BucketKey => {
  const d = daysFromToday(task.due_date);
  if (d < 0) return 'overdue';
  if (d === 0) return 'today';
  if (d <= 7) return 'thisWeek';
  if (d <= 14) return 'nextWeek';
  return 'later';
};

export const groupTasks = (tasks: Task[], includeDone: boolean): Record<BucketKey, Task[]> => {
  const result: Record<BucketKey, Task[]> = {
    overdue: [], today: [], thisWeek: [], nextWeek: [], later: [],
  };
  for (const t of tasks) {
    if (!includeDone && t.status === 'Done') continue;
    result[bucketFor(t)].push(t);
  }
  // Sort each bucket by due date
  for (const k of BUCKET_ORDER) {
    result[k].sort((a, b) => a.due_date.localeCompare(b.due_date));
  }
  return result;
};
